<template>
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12" text="true" headerTitle="true" :title="t('Add/Edit Product')">
                <div class="row g-xl-5 g-3">
                    
                    <AddProductContent />
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { productListLanguage } from '@/core/locales/product-list-language';

const { t } = useI18n({
    messages: productListLanguage
});
const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const AddProductContent = defineAsyncComponent(() => import("@/components/theme/ecommerce/addproduct/AddProductContent.vue"))
</script>